import React from 'react';

const SIZES = {
  sm: { word: 'text-lg', strap: 'text-[5.5px] tracking-[0.28em] pl-px' },
  md: { word: 'text-2xl', strap: 'text-[6.5px] tracking-[0.32em] pl-px' },
  lg: { word: 'text-3xl', strap: 'text-[8px] tracking-[0.36em] pl-[1.5px]' },
};

// Standard goLeicestershire logo — wordmark + STAY PLAY EXPLORE strapline.
export const BrandLogo = ({ size = 'md', dark = false, suffix = null, className = '' }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex items-baseline gap-0.5 ${className}`} data-testid="brand-logo">
      <span className={`font-display tracking-tight ${s.word} ${dark ? 'text-base' : 'text-charcoal'}`}>go</span>
      <span className="inline-flex flex-col leading-none">
        <span className="flex items-baseline">
          <span className={`font-display tracking-tight ${s.word} ${dark ? 'text-mustard' : 'text-heritage'}`}>Leicestershire</span>
          {suffix}
        </span>
        <span className={`uppercase font-medium ${s.strap} ${dark ? 'text-base/45' : 'text-charcoal/45'}`} data-testid="brand-strapline">
          Stay&nbsp;&nbsp;Play&nbsp;&nbsp;Explore
        </span>
      </span>
    </span>
  );
};

export default BrandLogo;
